import React from 'react';
import './HandicapOverrideModal.css';

const HandicapOverrideModal = ({
  isOpen,
  onSave, // New prop
  onCancel, // New prop
  players,
  roundPlayerHandicaps,
  customHandicaps,
  onCustomHandicapChange
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>Handicap Override</h2>
        </div>
        <div className="handicap-override-list">
          <div className="player-handicap-row header">
            <span className="player-name">Player</span>
            <span className="playing-handicap">Playing H'cap</span>
            <span className="custom-handicap-header">Custom H'cap</span>
          </div>
          {players.map(player => {
            const playingHandicap = roundPlayerHandicaps[player.id]?.playing_handicap ?? '';

            return (
              <div key={player.id} className="player-handicap-row">
                <span className="player-name">{player.name}</span>
                <span className="playing-handicap">{playingHandicap}</span>
                <input
                  type="number"
                  className="handicap-input"
                  placeholder="H'cap"
                  value={customHandicaps[player.id] ?? playingHandicap}
                  onChange={(e) => onCustomHandicapChange(player.id, e.target.value)}
                />
              </div>
            );
          })}
        </div>
        <div className="modal-footer">
          <button onClick={onCancel} className="cancel-button">Cancel</button>
          <button onClick={onSave} className="save-button">Save</button>
        </div>
      </div>
    </div>
  );
};

export default HandicapOverrideModal;